import BaseObject from '../../../base/base_object';

export default class GameStepInstanceDescriptor extends BaseObject {
    static CLASS = 'GameStepInstanceDescriptor';

    init(params) {
        this.stepPrototype = params.stepPrototype;
        this.stepParams = params.stepParams;
    }
}